import { Controller } from "@hotwired/stimulus"
import { Modal, Toast } from "bootstrap"
import successKid from '../images/memes/success-kid.gif'
import takeMyMoney from '../images/memes/shut-up-meme.gif'
import mindBlown from '../images/memes/mind-blown.gif'
import highFive from '../images/memes/high-five.gif'
import pointingUp from '../images/memes/pointing-up.gif'
import happyDance from '../images/memes/happy-dance.gif'


export default class extends Controller {
  static targets = ["memeContainer", "messageTitle", "messageSubtext", "form"]

  MEMES = [
    {
      image: successKid,
      alt: "Success Kid Meme",
      title: "Be a hero to your industry friends!",
      subtext: "Share VIN Match Pro and earn rewards"
    },
    {
      image: takeMyMoney,
      alt: "Take My Money Meme",
      title: "Know someone who needs better VIN data?",
      subtext: "We'll make it worth your while"
    },
    {
      image: mindBlown,
      alt: "Mind Blown Meme",
      title: "Let others discover the power of VIN Match Pro!",
      subtext: "Your referrals help the industry grow stronger"
    },
    {
      image: highFive,
      alt: "High Five Meme",
      title: "Team up with us to grow the community!",
      subtext: "Refer companies and earn rewards"
    },
    {
      image: pointingUp,
      alt: "Pointing Up Meme",
      title: "Know a company that could use this?",
      subtext: "Share the love and get rewarded"
    },
    {
      image: happyDance,
      alt: "Happy Dance Meme",
      title: "Spread the joy of accurate VIN data!",
      subtext: "Your referrals make everyone happy"
    }
  ]

  connect() {
    const modalElement = document.getElementById('referralModal')
    if (!modalElement) return

    this.modal = new Modal(modalElement)
    this.boundSetRandomMeme = this.setRandomMeme.bind(this)
    modalElement.addEventListener('show.bs.modal', this.boundSetRandomMeme)

    if (this.hasFormTarget) {
      this.boundSubmitHandler = this.handleSubmit.bind(this)
      this.formTarget.addEventListener('submit', this.boundSubmitHandler)
    }
  }

  async handleSubmit(event) {
    event.preventDefault()
    const form = this.formTarget
    const submitButton = form.querySelector('button[type="submit"]')

    if (!form.checkValidity()) {
      form.classList.add('was-validated')
      return
    }

    submitButton.disabled = true
    submitButton.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Submitting...'

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const formData = new FormData(form)

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrfToken },
        body: formData
      })

      submitButton.disabled = false
      submitButton.innerHTML = 'Submit Referral'

      if (response.ok) {
        this.handleSuccessfulSubmission()
      } else {
        alert('There was an error submitting your referral. Please try again.')
      }
    } catch {
      submitButton.disabled = false
      submitButton.innerHTML = 'Submit Referral'
      alert('There was an error submitting your referral. Please try again.')
    }
  }

  handleSuccessfulSubmission() {
    if (this.modal) {
      this.modal.hide()
      document.body.classList.remove('modal-open')
      const backdrop = document.querySelector('.modal-backdrop')
      if (backdrop) backdrop.remove()
    }

    this.formTarget.reset()
    this.formTarget.classList.remove('was-validated')

    setTimeout(() => {
      let toastContainer = document.querySelector('.toast-container')
      if (!toastContainer) {
        toastContainer = document.createElement('div')
        toastContainer.className = 'toast-container position-fixed top-0 end-0 p-3'
        document.body.appendChild(toastContainer)
      }

      const toastElement = document.createElement('div')
      toastElement.className = 'toast align-items-center text-white bg-success border-0'
      toastElement.setAttribute('role', 'alert')
      toastElement.setAttribute('aria-live', 'assertive')
      toastElement.setAttribute('aria-atomic', 'true')
      toastElement.innerHTML = `
        <div class="d-flex">
          <div class="toast-body">
            Thank you for your referral!
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      `
      toastContainer.appendChild(toastElement)

      try {
        const toast = new Toast(toastElement, { delay: 2000 })
        toast.show()
        toastElement.addEventListener('hidden.bs.toast', () => {
          toastElement.remove()
          if (!toastContainer.hasChildNodes()) toastContainer.remove()
        })
      } catch {
        alert('Thank you for your referral!')
      }
    }, 300)
  }

  disconnect() {
    const modalElement = document.getElementById('referralModal')
    if (modalElement && this.boundSetRandomMeme) {
      modalElement.removeEventListener('show.bs.modal', this.boundSetRandomMeme)
    }
    if (this.hasFormTarget && this.boundSubmitHandler) {
      this.formTarget.removeEventListener('submit', this.boundSubmitHandler)
    }
    if (this.modal) this.modal.dispose()
  }

  setRandomMeme() {
    const randomMeme = this.MEMES[Math.floor(Math.random() * this.MEMES.length)]

    if (this.hasMemeContainerTarget) {
      this.memeContainerTarget.innerHTML = `
        <img src="${randomMeme.image}" 
             alt="${randomMeme.alt}" 
             class="img-fluid" 
             style="max-height: 200px; object-fit: contain">
      `
    }

    if (this.hasMessageTitleTarget) {
      this.messageTitleTarget.innerHTML = randomMeme.title
    }

    if (this.hasMessageSubtextTarget) {
      this.messageSubtextTarget.innerHTML = randomMeme.subtext
    }
  }
} 